import React from 'react';
import Aux from '../Hoc/Aux';

import iconCheck from '../../assets/svg/icon-check.svg';
import iconCheckup from '../../assets/svg/icon-checkup.svg';
import iconPenny from '../../assets/svg/icon-penny.svg';
import iconOnline from '../../assets/svg/icon-online.svg';
import iconGym from '../../assets/svg/icon-gym.svg';
import iconGym02 from '../../assets/svg/icon-gym-02.svg';
import iconHospital from '../../assets/svg/icon-hospital.svg';
import iconNational from '../../assets/svg/icon-national.svg';
import iconHeartrate from '../../assets/svg/icon-heartrate.svg';
import iconLifePoints from '../../assets/svg/icon-pocket.svg';
import iconWeightManagement from '../../assets/svg/icon-weight-management.svg';
import iconCovered from '../../assets/svg/icon-covered.svg';
import iconMedicareDental from '../../assets/svg/icon-medicare-dental.svg';
import iconPhone from '../../assets/icon-medicare-phone.png';
import iconMedicareApp from '../../assets/icon-medicare-app.png';
// import iconMedicareVision from '../../assets/svg/icon-medicare-vision.svg';
// import iconPapaPals from '../../assets/svg/icon-papa-pals-02.svg';

const reasons = (props) => {
  const findADoc = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'Click',
      'eventAction': 'Load Website',
      'eventLabel': 'Find a Doc',
      'eventValue': undefined
    });
  };

  const introVar = props.intro;
  let intro;
  if (introVar) {
    if (introVar === 'true') {
      intro = <h2>A few reasons why you&rsquo;ll&nbsp;love&nbsp;us.</h2>;
    } else {
      intro = <h2>{introVar}</h2>;
    }
  }
  const padding = (props.intro === 'true') ? 'p60' : '';
  let divide = (props.divide) ? props.divide : '';
  let colNum = (props.colNum) ? props.colNum : '';

  let iconList;
  let searchLink = (props.search) ? props.search : 'https://findadoc.cdphp.com/';

  let national = (<li className='col'>
    <span><img src={iconNational} alt='Coverage from coast to coast, including at all the top hospitals' /></span>
    <p>Coverage from coast to coast,<br /> including at all the top hospitals</p>
  </li>);

  let hospital = (<li className='col'>
    <span><img src={iconHospital} alt='Access to most local doctor and Hospitals' /></span>
    <p>Access to most local doctors<br /> and hospitals (<a
      href={searchLink}
      target='_blank'
      rel='noopener noreferrer'
      onClick={findADoc}
    >search now</a>)</p>
  </li>);

  let checkout = (<li className='col'>
    <span><img src={iconCheckup} alt='Checkups, flu shots, and other preventive care at no cost to you' /></span>
    <p>Checkups, flu shots, and other preventive care at no cost to you</p>
  </li>);

  let check = (<li className='col'>
    <span><img src={iconCheck} alt='Pre-existing conditions' /></span>
    <p>Coverage for any and all<br /> pre-existing conditions</p>
  </li>);

  let penny = (<li className='col'>
    <span><img src={iconPenny} alt='Penny Prescription' /></span>
    <p>Low-cost prescriptions (a dollar a fill for nearly <a href='https://www.cdphp.com/members/rx-corner/drug-coverage/rx-for-less' target='_blank' rel='noopener noreferrer'>100 common drugs</a>)</p>
  </li>);

  let online = (<li className='col'>
    <span><img src={iconOnline} alt='Ability to see a doctor online' /></span>
    <p>Ability to see a doctor online<br /> 24/7 from the comfort of home</p>
  </li>);

  let gym = (<li className='col'>
    <span><img src={iconGym} alt='Free fitness classes' /></span>
    <p>Free fitness classes to help<br /> you stay healthy</p>
  </li>);

  let medicarePhysicals = (<li className='col'>
    <span><img src={iconHeartrate} alt='Physicals and preventive' /></span>
    <p>Physicals and preventive<br /> screenings at no cost to you</p>
  </li>);

  let essentialDental = (<li className='col'>
    <span><img src={iconCovered} alt='No cost dental and vision' /></span>
    <p>No cost dental and vision + expanded vision network</p>
  </li>);

  let essentialFitness = (<li className='col'>
    <span><img src={iconGym02} alt='Fitness reimbursement' /></span>
    <p>Fitness reimbursement,<br /> up to $400</p>
  </li>);

  let essentialWeight = (<li className='col'>
    <span><img src={iconWeightManagement} alt='Weight management reimbursement' /></span>
    <p>Weight management reimbursement, up to $75</p>
  </li>);

  let essentialLifePointsRewards = (<li className='col'>
    <span><img src={iconLifePoints} alt='CDPHP Life Points Rewards' /></span>
    <p>CDPHP Life Points Rewards for completing health-related activities, redeemable for gift cards and merchandise.</p>
  </li>);

  let medicareDental = (<li className='col'>
    <span><img src={iconMedicareDental} alt='Dental benefits' /></span>
    <p>Dental allowance on a prepaid benefits card to use at any dentist in&nbsp;the&nbsp;U.S.</p>
  </li>);

  let medicareApp = (<li className='col'>
    <span><img src={iconMedicareApp} alt='Digital Care App' /></span>
    <p>Digital care management app that delivers personalized care plans, education, and messaging at no cost to help you stay engaged in your&nbsp;care.</p>
  </li>);

  let medicarePrescription = (<li className='col'>
    <span><img src={iconPenny} alt='Prescription coverage starting' className='penny' /></span>
    <p>Save money on prescription drugs at preferred retail&nbsp;pharmacies</p>
  </li>);

  let medicareGym = (<li className='col'>
    <span><img src={iconGym} alt='15,000 gyms across the country' className='gyms' /></span>
    <p>Access to a national network of fitness centers and on-demand workout videos to stay active from the comfort of&nbsp;home</p>
  </li>);

  let medicarePhone = (<li className='col'>
    <span><img src={iconPhone} alt='Phone' /></span>
    <p>24/7 phone access to registered nurses for education and support at no additional cost</p>
  </li>);

  // let medicarePapaPals = (<li className='col'>
  //   <span><img src={iconPapaPals} alt='Papa Pals' className='gyms' /></span>
  //   <p>Up to 60 hours of in-home support services from a trained Papa Pal</p>
  // </li>);

  // let medicareVision = (<li className='col'>
  //   <span><img src={iconMedicareVision} alt='Vision benefits' /></span>
  //   <p>Digital care management app that delivers personalized care plans, education, and messaging at no cost to help you stay engaged in yourcare.</p>
  // </li>);

  if (props.type === 'biz') {
    iconList = (
      <Aux>
        {national}
        {checkout}
        {check}
        {penny}
        {online}
        {gym}
      </Aux>
    );
  } else if (props.type === 'medicare') {
    iconList = (
      <Aux>
        {medicareDental}
        {medicarePhysicals}
        {medicarePhone}
        {medicareApp}
        {medicarePrescription}
        {medicareGym}
      </Aux>
    );
  } else if (props.type === 'medicareWNY') {
    iconList = (
      <Aux>
        {medicareDental}
        {medicarePhysicals}
        {medicarePhone}
        {medicareApp}
        {medicarePrescription}
        {medicareGym}
      </Aux>
    );
  } else if (props.type === 'essential') {
    iconList = (
      <Aux>
        {essentialFitness}
        {essentialWeight}
        {essentialLifePointsRewards}
        {checkout}
        {essentialDental}
        {online}
        {penny}
        {check}
        {hospital}
      </Aux>
    );
  } else {
    iconList = (
      <Aux>
        {hospital}
        {checkout}
        {check}
        {penny}
        {online}
        {gym}
      </Aux>
    );
  }

  return (
    <section className={divide + ' ' + padding}>
      <div className='wrap'>
        {intro}
        <ul className={'three-col reasons ' + colNum}>
          {iconList}
        </ul>
      </div>
    </section>
  );
};

export default reasons;
